'use client';

import { useState } from 'react';
import { FaXTwitter, FaLinkedin, FaFacebook } from 'react-icons/fa6';
import { FiLink, FiCheck } from 'react-icons/fi';

interface InsiderTradesShareButtonsProps {
  title?: string;
  url?: string;
}

export function InsiderTradesShareButtons({
  title = 'Insider Trades · Benzinga',
  url,
}: InsiderTradesShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  const open = (shareUrl: string) => {
    if (typeof window !== 'undefined') {
      window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=500');
    }
  };

  const resolveHref = () => {
    if (typeof window !== 'undefined') return window.location.href;
    return url ?? 'https://www.benzinga.com/sec/insider-trades';
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(resolveHref());
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* noop */
    }
  };

  const href = resolveHref();
  const enc = encodeURIComponent;
  const buttonClass =
    'w-9 h-9 flex items-center justify-center bg-[#1A1F2E] hover:bg-[#2A3145] border border-[#2A3145] rounded-md text-[#9fb3c8] hover:text-white transition-colors';

  return (
    <div className="flex flex-row items-center gap-1.5 sm:gap-2" aria-label="Share">
      <button
        aria-label="Share on X"
        className={buttonClass}
        onClick={() => open(`https://twitter.com/intent/tweet?url=${enc(href)}&text=${enc(title)}`)}
        type="button"
      >
        <FaXTwitter size={14} />
      </button>
      <button
        aria-label="Share on LinkedIn"
        className={buttonClass}
        onClick={() => open(`https://www.linkedin.com/sharing/share-offsite/?url=${enc(href)}`)}
        type="button"
      >
        <FaLinkedin size={14} />
      </button>
      <button
        aria-label="Share on Facebook"
        className={buttonClass}
        onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${enc(href)}`)}
        type="button"
      >
        <FaFacebook size={14} />
      </button>
      <button aria-label="Copy link" className={buttonClass} onClick={handleCopy} type="button">
        {copied ? <FiCheck className="text-[#30BF60]" size={14} /> : <FiLink size={14} />}
      </button>
    </div>
  );
}
